import { useRouter } from 'next/router';
import React, { useCallback, useEffect } from 'react';
import {
    useResetSearchKeyword,
    useSearchKeyword,
    useSetSearchKeyword,
} from 'src/features/common/search/hooks/search.hooks';
import { useClearSearchInput, useInputSearch } from 'src/features/common/search/hooks/use-input-search';
import { DesktopSearch } from './desktop-search';
import { MobileSearch } from './mobile-search';

export const HeaderSearch = () => {
    const { query } = useRouter();
    const setSearchKeyword = useSetSearchKeyword();
    const resetSearchKeyword = useResetSearchKeyword();
    const searchKeyword = useSearchKeyword();
    const inputSearch = useInputSearch();
    const clearSearch = useClearSearchInput();

    const onSubmit = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            inputSearch(searchKeyword);
        },
        [inputSearch, searchKeyword]
    );

    useEffect(() => {
        query.query && setSearchKeyword(query.query as string);
    }, [query, setSearchKeyword]);

    const handleChange = useCallback((e) =>{
        setSearchKeyword(e.target.value);
    }, [setSearchKeyword]);

    const handleClear = async () => {
        resetSearchKeyword();
        clearSearch();
    };

    return (
        <>
            <DesktopSearch
                onSubmit={onSubmit}
                searchValue={searchKeyword}
                onChange={handleChange}
                onClear={handleClear}
            />
            <MobileSearch
                onSubmit={onSubmit}
                searchValue={searchKeyword}
                onChange={handleChange}
                onClear={resetSearchKeyword}
            />
        </>
    );
};
